import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiDeleteEmailTemplate, apiGetEmailTemplateAsync } from 'services/EmailTemplateServices'

export const getEmailTemplateList = createAsyncThunk('emailTemplatesList/data/getLEmailTemplateList',async (data) => {
    const response = await apiGetEmailTemplateAsync(data)
    return response.data
})

export const deleteEmailTemplate = async (data) => {
    const response = await apiDeleteEmailTemplate(data)
    return response
}

export const initialTableData = {
    total: 0,
    pageIndex: 1,
    pageSize: 10,
    webLangId: 1,
    query: '',
    sort: {
        order: '',
        key: ''
    }
}

const dataSlice = createSlice({
    name: 'emailTemplatesList/data',
    initialState: {
        loading: false,
        productList: [],
        tableData: initialTableData,
    },
    reducers: {
        updateProductList: (state, action) => {
            state.productList = action.payload
        },
        setTableData: (state, action) => {
            state.tableData = action.payload
        },
    },
    extraReducers: {
        [getEmailTemplateList.fulfilled]: (state, action) => {
            state.productList = action.payload.data
            state.tableData.total = action.payload.total
            state.loading = false
        },
        [getEmailTemplateList.pending]: (state) => {
            state.loading = true
        },
    }
})
export const { updateProductList, setTableData, setFilterData, setSortedColumn } = dataSlice.actions

export default dataSlice.reducer
